<div class="tooltip" [ngStyle]="{ top: position.top, left: position.left }" [innerHTML]="text" *ngIf="text.length">
</div>